var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-bg-white dialog-container tw-rounded tw-grid tw-overflow-hidden tw-max-h-[90vh-4px)] tw-transition-all tw-duration-300 tw-shadow-2xl"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }